import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { AdminUser } from 'src/types/admin-users';

type MeState = {
  me: AdminUser | null;
  loading: boolean;
  error: string | null;
};

type Actions = {
  setLoading: (loading: boolean) => void;
  setMe: (newMe: AdminUser | null) => void;
  setMeFromLogin: (adminUser: any) => void;
  clearMe: () => void;
};

const initialValues: MeState = {
  me: null,
  loading: false,
  error: null,
};

export const useMeStore = create<MeState & Actions>()(
  persist(
    (set) => ({
      ...initialValues,

      setLoading: (loading: boolean) => set({ loading }),

      setMe: (me: AdminUser | null) => set({ me }),

      setMeFromLogin: (adminUser: any) => {
        if (adminUser) {
          const user: AdminUser = {
            id: adminUser.id,
            displayName: adminUser.displayName || adminUser.name || adminUser.email.split('@')[0],
            email: adminUser.email,
            status: adminUser.status,
            undemotable: Boolean(adminUser.undemotable),
            permissions: adminUser.permissions,
          };
          set({ me: user });
        }
      },

      clearMe: () => set({ me: null, error: null }),
    }),
    {
      name: 'me-storage',
      partialize: (state) => ({ me: state.me }),
    }
  )
);
